import { tableStore } from '../../stores';

export const usePifPanel = () => {
  const { dataForCompiling, originalPifCompilerDiagnostics, pifErrors, rows } =
    tableStore;

  const diagnostics = JSON.stringify(originalPifCompilerDiagnostics, null, 2);

  return {
    diagnostics,
    dataForCompiling,
    pifErrors,
    rows: JSON.stringify(rows, null, 2),
  };
};
